import { Applicant } from './applicant';
import { ApplicantDetails } from './applicantDetails';
import { ApplicantsService } from './applicant.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CertificationService } from './certification.service';
import { CommonService } from '../common/common.services';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ContactInfoService } from './contact-information.service';
import { Country } from '../common/country';
import { EducationalBackgroundService } from './educational-background.service';
import { ExaminationService } from './examinations-taken.service';
import { ExaminationSubjectService } from './examination-subject.service';
import { FinanceStudyService } from './finance-study.service';
import { Gender } from './gender';
import { Observable } from 'rxjs';
import { PersonService } from './person.service';
import { Portfolio } from './portfolio';
import { PortfolioService } from './portfolio-review.service';
import { PreUniversityService } from './previous.university.service';
import { ProgrammeSelectionService } from '../accepted-applicants/programme-selection.service';
import { ProgrammeType } from '../common/programmeType';
import { Region } from './region';
import { Religion } from '../common/religion';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from './title';
import { certificate } from './certificate';
import { examinationsubjects } from './examination-subjects';
import { map, shareReplay } from 'rxjs/operators';
import { SignUpService } from '../sign-ups/sign-ups.service';
import { ToastrService } from 'ngx-toastr';


export interface ApplicantData {
  ID: number;
  examination: string;
  index_number: string;
  date: string;
  certificate_name: string;
}

const APPLICANT_DATA: ApplicantData[] = [];

@Component({
  selector: 'app-applicant',
  templateUrl: './applicant.component.html',
  styleUrls: ['./applicant.component.scss'],
})
export class ApplicantComponent implements OnInit {
  applicantDetails: ApplicantDetails;
  title: Title;
  surname: string;
  firstName: string;
  middleName: string;
  otherName: string;
  email: string;
  mobileno: string;
  phoneno: string;
  gender: Gender;
  specialNeeds: string;
  specialNeedDetails: string;
  placeOfBirth: string;
  placeOfBirthId: string;
  photoName: string;
  hometown: string;
  hometownId: string;
  dob: Date;
  applicantFullName: string;
  programmeType: ProgrammeType;
  programmeTypeId: string;
  programmeId: any;
  signUpApplicant: any;
  applicationRecievedDate: string;

  dropdownList = [];
  dropdownListGender = [];
  religionList: Religion[];
  regionList: Region[];
  countryofBirthList: Country[];
  nationalityList: Country[];
  dropdownListCityofBirth = [];
  programmeList = [];
  programmeTypeList = [];
  titleList: Title[];
  genderList: Gender[];
  photolink: string;
  certificateLink: string;
  countryOfBirth: Country;
  nationality: Country;
  region: Region;
  religion: Religion;
  applicant: Applicant;
  programme: any;
  examinationTakenList = [];
  relationship: string;
  others: string;
  portfolioList = [];

  refreefullname: string;
  refreeemailaddress: string;
  refreeoccupation: string;
  refreedate: string;
  refreetitle: string;
  refreeposition: string;
  displayedColumns: string[] = [
    'id',
    'ExamType',
    'index_number',
    'results_slip',
    'certificate_name',
  ];
  dataSource = [];
  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result: { matches: any }) => result.matches),
      shareReplay(),
    );
  postalAddress1: any;
  postalAddress2: any;
  postalCityTown: string;
  postalCityId: string;
  postalCountry: any;
  dropdownListCountryPost: any;
  selectedItemsCountryPost: any;
  postalState: any;
  postalPostcode: any;
  permanentAddress1: any;
  permanentAddress2: any;
  permanentCityTown: string;
  permanentCityId: string;
  permanentCountry: any;
  dropdownListCountryPermanent: any;
  selectedItemsCountryPermanent: any;
  permanentState: any;
  permanentPostcode: any;
  postalAddressNationality: Country;
  permanentAddressNationality: Country;
  sponsorOccupation: string;
  sponsorCompany: string;
  sponsorCountryList: Country[];
  sponsorCountry: Country;
  contactId: string;
  sponsorId: string;
  sponsortelephone: string;
  sponsormobileNo: string;
  sponsorpermanentAddressId: string;
  sposorpostalAddressId: string;
  sponsorPersonId: string;
  sponsorTitle: string;
  sponsorFirstName: string;
  sponsorMiddleName: string;
  sponsorSurname: string;
  sponsorEmail: string;
  sponsorAddress1: any;
  sponsorAddress2: any;
  sponsorState: any;
  sponsorPostalcode: any;
  sponsorRelationship: string;
  institution: string;
  educationalBackgroundCityName: string;
  educationalBackgroundCountryName: string;
  educationBackgroundStartDate: string;
  educationBackgroundCompleteDate: string;
  educationBackgroundQualification: string;
  educationBackgroundotherQualification: string;
  examinationsubjectsList: examinationsubjects[];
  previousAttendanceCollegeName: string;
  previousAttendanceFullName: string;
  previousAttendanceAdmissionDate: string;
  previousAttendanceHostel: string;
  previousAttendanceProgramme: string;
  previousAttendanceLastYearOfStudy: string;
  previousAttendanceReasonOfLeaving: string;

  sponsorCity: any;
  personId: string;
  applicantSignature: string;
  referenceId: string;
  financingOptionId: string;
  applicantStatus: string;
  applicantStatusList: string[];
  enrolled: string;
  applicationNo: string;
  public loading = false;
  semester:number;

  selectedSemester: string; // or initialize with an appropriate default value






  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private applicantsService: ApplicantsService,
    private commonService: CommonService,
    private breakpointObserver: BreakpointObserver,
    private contactInfoService: ContactInfoService,
    private programmeSelectionService: ProgrammeSelectionService,
    private examinationService: ExaminationService,
    private examinationSubjectService: ExaminationSubjectService,
    private educationalBackgroundService: EducationalBackgroundService,
    private portfolioService: PortfolioService,
    private financeStudyService: FinanceStudyService,
    private certificationService: CertificationService,
    private personService: PersonService,
    private preUniversityService: PreUniversityService,
    private signupService: SignUpService,
    private toaster: ToastrService,
    private cdr: ChangeDetectorRef
  ) {}

 

  

  ngOnInit() {
    this.loading = true;
    setTimeout(()=>{
      console.log('Appplicant details');
      this.loading = false;
    }, 3000)

    this.route.queryParams.subscribe(
      (params: { applicantId: any; year: any }) => {
        let applicantId = params.applicantId;
        this.personId = applicantId;
        let year = params.year;
        this.applicantStatusList = ['WAITLISTED', 'REJECTED', 'ACCEPTED', 'REGISTERED'];

        this.initializeTitle(applicantId);
        this.populateContactInformation(applicantId);
        this.populateProgrammeSelection(applicantId);
        this.populateEducationalBackground(applicantId);
        this.populatePreviousAttendance(applicantId);
        this.populateExaminationTaken(applicantId);
        this.populateExaminationSubject(applicantId);
        this.populatePortfolioReview(applicantId);
        this.populateSponsorParticular(applicantId);
        this.populateFinancingYourStudy(applicantId);
        this.populateReferee(applicantId);
      },
    );
  }
  populateExaminationSubject(applicantId: any) {
    this.examinationSubjectService
      .getSubjectList(applicantId)
      .subscribe((response: examinationsubjects[]) => {
        this.examinationsubjectsList = response;
      });
  }

  private populateApplicantDetails(applicantId: any) {
    this.applicantsService
      .getPersonDetails(applicantId)
      .subscribe(
        (person: {
          surname: string;
          firstName: string;
          middleName: string;
          otherName: string;
          passportPhoto: string;
          salutation: string;
          gender: string;
          countryOfBirth: string;
          nationalityId: string;
          region: string;
          religionId: string;
          placeOfBirth: String;
          homeTownId: String;
          dob: string | number | Date;
          email: string;
          specialNeedsStatus: string;
          specialNeeds: string;
        }): void => {
          this.surname = person.surname;
          this.firstName = person.firstName;
          this.middleName =
            person.middleName === 'undefined' ? '' : person.middleName;
          this.otherName = person.otherName === 'null' ? '' : person.otherName;
          this.applicantFullName =
            this.firstName + ' ' + this.middleName + ' ' + this.surname;
          this.photoName = person.passportPhoto;
          this.photolink = this.commonService.getPassPortPhotoUrl(
            this.photoName,
          );
          this.titleList.filter((title) => {
            if (title.titleid === person.salutation) this.title = title;
          });
          this.genderList.filter((gender) => {
            if (
              gender.genderid == person.gender ||
              gender.gender == person.gender
            )
              this.gender = gender;
          });
          this.countryofBirthList.filter((country) => {
            if (country.countryCode === person.countryOfBirth)
              this.countryOfBirth = country;
          });
          this.nationalityList.filter((country) => {
            if (country.countryCode === person.nationalityId)
              this.nationality = country;
          });

          this.regionList.filter((region) => {
            if (region.regionid === person.region) {
              this.region = region;
            }
          });
          this.religionList.filter((religion) => {
            if (religion.religionId.toString() == person.religionId) {
              this.religion = religion;
            }
          });
          this.commonService
            .getCityName(person.placeOfBirth)
            .subscribe((cityData: { city: string; cityId: string }) => {
              if (cityData !== null) {
                this.placeOfBirth = cityData.city;
                this.placeOfBirthId = cityData.cityId;
              }
            });
          this.commonService
            .getCityName(person.homeTownId)
            .subscribe((city: { city: string; cityId: string }) => {
              if (city !== null) {
                this.hometown = city.city;
                this.hometownId = city.cityId;
              }
            });
          this.dob = new Date(person.dob);
          this.email = person.email;
          this.specialNeeds = person.specialNeedsStatus;
          this.specialNeedDetails = person.specialNeeds;

          // Fetch the mobile number using getSignUpApplicantById
          this.signupService
            .getSignUpApplicantId(person.email)
            .subscribe((data) => {
              this.mobileno = data.contact_no;
            });
        },
      );
  }

  private populateSponsorParticular(applicantId: any) {
    this.financeStudyService
      .getSponsorDetails(applicantId)
      .subscribe(
        (sponsor: {
          relationship: string;
          occupation: string;
          company: string;
          contactId: string;
          sponsorId: string;
        }) => {
          this.sponsorRelationship = sponsor.relationship;
          this.sponsorOccupation = sponsor.occupation;
          this.sponsorCompany = sponsor.company;
          this.contactId = sponsor.contactId;
          this.sponsorId = sponsor.sponsorId;
          this.contactInfoService
            .getContactById(sponsor.contactId)
            .subscribe(
              (contact: {
                landPhone: string;
                mobilePhone: string;
                permanentAddressId: string;
                postalAddressId: string;
                personId: string;
              }) => {
                this.sponsortelephone = contact.landPhone;
                this.sponsormobileNo = contact.mobilePhone;
                this.sponsorpermanentAddressId = contact.permanentAddressId;
                this.sposorpostalAddressId = contact.postalAddressId;
                this.sponsorPersonId = contact.personId;
                this.personService
                  .getPersonById(contact.personId)
                  .subscribe(
                    (person: {
                      salutation: string;
                      firstName: string;
                      middleName: string;
                      surname: string;
                      email: string;
                      personId: string;
                    }) => {
                      this.titleList.forEach((title) => {
                        if (title.titleid === person.salutation)
                          return (this.sponsorTitle = title.title);
                      });
                      this.sponsorFirstName = person.firstName;
                      this.sponsorMiddleName =
                        person.middleName == 'undefined'
                          ? ''
                          : person.middleName;
                      this.sponsorSurname = person.surname;
                      this.sponsorEmail =
                        person.email == 'undefined' ? '' : person.email;
                      this.sponsorPersonId = person.personId;
                    },
                  );

                this.contactInfoService
                  .getAddressInfo(contact.permanentAddressId)
                  .subscribe((address) => {
                    this.sponsorAddress1 = address[0].address1;
                    this.sponsorAddress2 =
                      address[0].address2 == 'undefined'
                        ? ''
                        : address[0].address2;
                    this.sponsorState =
                      address[0].state == 'undefined' || undefined
                        ? ''
                        : address[0].state;
                    this.sponsorPostalcode =
                      address[0].postalCode == 'undefined'
                        ? ''
                        : address[0].postalCode;
                    this.contactInfoService
                      .getCountryNameByCityId(address[0].cityId)
                      .subscribe((city: { city: any; countryCode: string }) => {
                        this.sponsorCity = city.city;
                        this.sponsorCountryList.forEach((sponsorCountry) => {
                          if (sponsorCountry.countryCode == city.countryCode)
                            this.sponsorCountry = sponsorCountry;
                        });
                      });
                  });
              },
            );
        },
      );
  }

  private populateContactInformation(applicantId: any) {
    this.contactInfoService
      .getContactInfo(applicantId)
      .subscribe((contactDetails) => {
        this.mobileno = contactDetails[0].mobilePhone;
        this.phoneno = contactDetails[0].landPhone;
        let permanentAddressId = contactDetails[0].permanentAddressId;
        let postalAddressId = contactDetails[0].postalAddressId;
        this.contactInfoService
          .getAddressInfo(postalAddressId)
          .subscribe((postalAddress: any) => {
            this.displayPostalAddress(postalAddress);
            this.contactInfoService
              .getAddressInfo(permanentAddressId)
              .subscribe((permanentAddress: any) => {
                this.displayPermanentAddress(permanentAddress);
              });
          });
      });
  }

  private populateProgrammeSelection(applicantId: any): void {
    this.programmeSelectionService
      .getApplicantDetails(applicantId)
      .subscribe((applicant: Applicant) => {
        this.applicant = applicant;
        this.applicationRecievedDate = this.applicant.applicationReceivedDate;
        this.applicantStatus = this.applicant.applicationStatus;

        this.selectedSemester = this.applicant.semester; 
        // console.log('Selected Semester:', this.selectedSemester);
        this.applicationNo =
          this.applicant.registrationNumber === 'undefined'
            ? ''
            : this.applicant.registrationNumber;
        this.commonService
          .getProgrammeTypes()
          .subscribe((programmeTypeList: any[]) => {
            this.programmeTypeList = programmeTypeList;
            this.programmeTypeList.filter((programmeType) => {
              if (
                programmeType.programmeTypeId === this.applicant.programmeTypeId
              ) {
                this.programmeType = programmeType;
                if (this.programmeType.programmeTypeId === '0') {
                  this.commonService
                    .getCertificateProgrammeList()
                    .subscribe((certificateprogrammeList: any[]) => {
                      this.programmeList = certificateprogrammeList;
                      this.programmeList.filter((programme) => {
                        if (
                          programme.programmeId === this.applicant.programmeId
                        )
                          this.programme = programme;
                      });
                    });

                } else {
                  this.programmeSelectionService
                    .getProgrammeList()
                    .subscribe((programmeList: any[]) => {
                      this.programmeList = programmeList;
                      this.programmeList.filter((programme) => {
                        if (
                          programme.programmeId === this.applicant.programmeId
                        )
                          this.programme = programme;
                      });
                    });   
                }
              }
            });
          });
      });
      this.cdr.detectChanges(); // Trigger change detection   
  }

  private populateEducationalBackground(applicantId: any) {
    this.educationalBackgroundService
      .getEducationalBackgroundDetails(applicantId)
      .subscribe((educationalBackgroundDetails) => {
        this.commonService
          .getCityName(educationalBackgroundDetails[0].cityId)
          .subscribe((city: { city: string }) => {
            this.commonService
              .getCountryName(educationalBackgroundDetails[0].countryId)
              .subscribe((country: { country: string }[]) => {
                this.institution = educationalBackgroundDetails[0].institution;
                this.educationalBackgroundCityName = city.city;
                this.educationalBackgroundCountryName = country[0].country;
                this.educationBackgroundStartDate =
                  educationalBackgroundDetails[0].startDate;
                this.educationBackgroundCompleteDate =
                  educationalBackgroundDetails[0].completionDate;
                this.educationBackgroundQualification =
                  educationalBackgroundDetails[0].qualification;
                this.educationBackgroundotherQualification =
                  educationalBackgroundDetails[0].otherQualification;
              });
          });
      });
  }

  populatePreviousAttendance(applicantId: string) {
    this.preUniversityService
      .getPreviousEnrolment(applicantId)
      .subscribe(
        (previousEnrollment: {
          previousEnrollment: string;
          universityName: string;
          namesUsed: string;
          admissionYear: string;
          residencyName: string;
          programmeOfStudy: string;
          lastYearOfStudy: string;
          reasonsForLeaving: string;
        }) => {
          if (
            previousEnrollment !== null &&
            previousEnrollment.previousEnrollment !== '0'
          ) {
            this.enrolled = '1';
          } else {
            this.enrolled = '0';
          }
          this.previousAttendanceCollegeName =
            previousEnrollment.universityName;
          this.previousAttendanceFullName = previousEnrollment.namesUsed;
          this.previousAttendanceAdmissionDate =
            previousEnrollment.admissionYear;
          this.previousAttendanceHostel = previousEnrollment.residencyName;
          this.previousAttendanceProgramme =
            previousEnrollment.programmeOfStudy;
          this.previousAttendanceLastYearOfStudy =
            previousEnrollment.lastYearOfStudy;
          this.previousAttendanceReasonOfLeaving =
            previousEnrollment.reasonsForLeaving;
        },
      );
  }

  private populateExaminationTaken(applicantId: any) {
    this.examinationService
      .getCertificates(applicantId)
      .subscribe((certificateDetails: certificate[]) => {
        this.examinationTakenList = certificateDetails;
        this.certificateLink = this.commonService.getCertificateUrl(
          this.personId + '_' + certificateDetails[0].results,
        );
      });
  }

  private populatePortfolioReview(applicantId: any) {
    this.portfolioService
      .getPortfolioList(applicantId)
      .subscribe((response: any[]) => {
        response.forEach((portfolio: Portfolio) => {
          this.commonService.getPortfolioUrl(portfolio);
          this.portfolioList.push(portfolio);
        });
      });
  }

  private populateFinancingYourStudy(applicantId: any) {
    this.financeStudyService
      .getFinancingDetails(applicantId)
      .subscribe((financingDetailsList: string | any[]) => {
        this.others =
          financingDetailsList.length > 0 ? financingDetailsList[0].others : '';
        this.financingOptionId = financingDetailsList[0].financingOptionId;
      });
  }

  private populateReferee(applicantId: any) {
    this.certificationService
      .getCertificationbyPersonId(applicantId)
      .subscribe(
        (response: {
          title: string;
          position: string;
          fullName: string;
          emailAddress: string;
          occupation: string;
          certificationDate: string;
          signature: string;
          certificationId: string;
        }) => {
          this.refreetitle = response.title;
          this.refreeposition = response.position;
          this.refreefullname = response.fullName;
          this.refreeemailaddress = response.emailAddress;
          this.refreeoccupation = response.occupation;
          this.refreedate = response.certificationDate;
          this.applicantSignature = response.signature;
          this.referenceId = response.certificationId;
        },
      );
  }

  displayPostalAddress(postalAddress) {
    this.postalAddress1 = postalAddress[0].address1;
    this.postalAddress2 =
      postalAddress[0].address2 !== 'undefined'
        ? postalAddress[0].address2
        : '';
    this.commonService
      .getCityName(postalAddress[0].cityId)
      .subscribe((city: { city: string; cityId: string }) => {
        this.postalCityTown = city.city;
        this.postalCityId = city.cityId;
        this.contactInfoService
          .getCountryNameByCityId(city.cityId)
          .subscribe((country: { countryCode: any }) => {
            this.postalCountry = country.countryCode;
            console.log('selected country ' + this.postalCountry);
            this.nationalityList.filter((item) => {
              if (item.countryCode === this.postalCountry)
                this.postalAddressNationality = item;
            });
          });
      });
    this.postalState =
      postalAddress[0].state !== 'undefined' ? postalAddress[0].state : '';
    this.postalPostcode =
      postalAddress[0].postalCode !== 'undefined'
        ? postalAddress[0].postalCode
        : '';
  }

  displayPermanentAddress(permanentAddress) {
    this.permanentAddress1 = permanentAddress[0].address1;
    this.permanentAddress2 =
      permanentAddress[0].address2 !== 'undefined'
        ? permanentAddress[0].address2
        : '';
    this.commonService
      .getCityName(permanentAddress[0].cityId)
      .subscribe((city: { city: string; cityId: string }) => {
        this.permanentCityTown = city.city;
        this.permanentCityId = city.cityId;
        this.contactInfoService
          .getCountryNameByCityId(city.cityId)
          .subscribe((country: { countryCode: any }) => {
            this.permanentCountry = country.countryCode;
            this.nationalityList.filter((item) => {
              if (item.countryCode === this.permanentCountry)
                this.permanentAddressNationality = item;
            });
          });
      });
    this.permanentState =
      permanentAddress[0].state !== 'undefined'
        ? permanentAddress[0].state
        : '';
    this.permanentPostcode =
      permanentAddress[0].postalCode !== 'undefined'
        ? permanentAddress[0].postalCode
        : '';
  }

  private initializeTitle(applicantId: any) {
    this.commonService.getTitleList().subscribe((response: Title[]) => {
      this.titleList = response;
      this.initializeGender(applicantId);
    });
  }

  private initializeGender(applicantId: any) {
    this.commonService.getGenderList().subscribe((genderList: Gender[]) => {
      this.genderList = genderList;
      this.initializeRegion(applicantId);
    });
  }
  private initializeRegion(applicantId: any) {
    this.commonService.getRegionList().subscribe((regionList: Region[]) => {
      this.regionList = regionList;
      this.initializeCityOfBirth(applicantId);
    });
  }

  private initializeCityOfBirth(applicantId: any) {
    this.commonService.getCountryList().subscribe((countryList: Country[]) => {
      this.countryofBirthList = countryList;
      this.nationalityList = countryList;
      this.sponsorCountryList = countryList;
      this.initializeReligion(applicantId);
    });
  }

  private initializeReligion(applicantId: any) {
    this.commonService.getReligion().subscribe((religionList: Religion[]) => {
      this.religionList = religionList;
      this.populateApplicantDetails(applicantId);
    });
  }

  saveApplicantDetails() {
    this.loading = true;
    this.applicant.programmeTypeId = this.applicant.programmeTypeId;
    this.applicant.programmeId = this.applicant.programmeId;
    this.applicant.applicantType =
      this.applicant.applicantType === undefined
        ? 'REGULAR'
        : this.applicant.applicantType;
        this.applicant.semester = this.selectedSemester;
    this.applicant.applicationStatus = this.applicantStatus;
    this.applicant.applicationReceivedDate =
      this.applicant.applicationReceivedDate;
    this.applicant.registrationNumber = this.applicationNo;
    this.commonService
      .getCurrentYear()
      .subscribe((response: { response: any }) => {
        let currentYear = response.response;
        this.programmeSelectionService
          .saveApplicant(this.applicant, currentYear)
          .subscribe((applicantId: any) => {
            // console.log(this.applicant.applicationStatus);
            this.loading = true
            setTimeout(()=>{
              console.log('Success');
              this.toaster.success('AUCDT success','Applicant information registered successfully!',{
                positionClass: 'toast-top-center', 
              });
              this.loading = false;
            }, 3000)
          });

      });
  }
}
